import { useDataValue } from 'Simple/Data'

export default function useDataConfiguration(props) {
  let patient_id = useDataValue({
    viewPath: props.viewPath,
    context: 'tab',
    path: 'patient_id',
  })
  let deleted = useDataValue({
    context: 'tab',
    path: 'selected.images.show_deleted_image_series',
    viewPath: props.viewPath,
  })

  return {
    variables: {
      patient_id,
      deleted: deleted === false ? { _eq: false } : {},
    },
  }
}
